"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _lodash = _interopRequireDefault(require("lodash.memoize"));

var _moment = _interopRequireDefault(require("moment"));

var _uiKit = require("@devsta/ui-kit");

var _getValueFromGenericInput = require("@devsta/get-value-from-generic-input");

var _SubscriptionBlock = _interopRequireDefault(require("../../SubscriptionBlock"));

var _packageTemplates = _interopRequireDefault(require("../constants/packageTemplates"));

var _requiredPackageFields = _interopRequireDefault(require("../constants/requiredPackageFields"));

var _billingRegions = _interopRequireDefault(require("../constants/billingRegions"));

var _utils = require("../utils");

var _ManageSubscription = _interopRequireDefault(require("./ManageSubscription"));

var _AddonSelector = _interopRequireDefault(require("./AddonSelector"));

var _IncludedAddons = _interopRequireDefault(require("./IncludedAddons"));

require("../styles/_subscription-package.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }
}

var CUSTOM_SUFFIX = ' (CUSTOM)';

function getDefaultBillingEntityCodeOption(billingEntityCode) {
  if (!billingEntityCode) {
    return null;
  }

  return _billingRegions.default.find(function (_ref) {
    var value = _ref.value;
    return value === billingEntityCode;
  });
}

function createDatePayload(date) {
  if (!date || typeof date === 'string') {
    return date;
  }

  return date.format('YYYY-MM-DDTHH:mm:ss.sssZ');
}

var getPackageName = function getPackageName(subPackage) {
  return "".concat(subPackage.templatedFrom).concat(subPackage.custom ? CUSTOM_SUFFIX : '');
};

var formatDate = function formatDate(date) {
  return (0, _moment.default)(date).format('YYYY/MM/DD');
};

var buildAssignedPackageDescription = function buildAssignedPackageDescription(_ref2) {
  var videoQuantity = _ref2.videoQuantity,
      slaTurnaround = _ref2.slaTurnaround,
      storageAllowance = _ref2.storageAllowance,
      subStart = _ref2.subStart,
      subEnd = _ref2.subEnd;
  return ["".concat(videoQuantity > 1 ? videoQuantity : 'Unlimited', " Videos | ").concat(slaTurnaround, "hrs SLA | ").concat(storageAllowance > 0 ? storageAllowance : 'Unlimited')].concat(_toConsumableArray(subStart && subEnd ? ["".concat(formatDate(subStart), " - ").concat(formatDate(subEnd))] : []));
};

function isModalSaveDisabled(packageData) {
  return _requiredPackageFields.default.some(function (key) {
    return packageData && !packageData[key];
  });
}

function updateLocalPackageTemplate(newPackage) {
  var packages = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _packageTemplates.default;

  if (!newPackage || !newPackage.custom) {
    return packages;
  }

  var newPackages = _toConsumableArray(packages);

  var index = newPackages.findIndex(function (singlePackage) {
    return singlePackage.name === newPackage.templatedFrom;
  });
  newPackages.splice(index, 1, newPackage);
  return newPackages;
}

var SubscriptionPackage = /*#__PURE__*/function (_Component) {
  _inherits(SubscriptionPackage, _Component);

  function SubscriptionPackage(_ref3) {
    var _this;

    var _assignedPackage = _ref3.assignedPackage;

    _classCallCheck(this, SubscriptionPackage);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SubscriptionPackage).call(this));

    _defineProperty(_assertThisInitialized(_this), "updateCustomPackage", (0, _lodash.default)(function (fieldName) {
      var _ref4 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          isString = _ref4.isString;

      return function (value) {
        var selectedPackage = _this.state.selectedPackage;
        var getValue = isString ? _getValueFromGenericInput.getStringValueFromGenericInput : _getValueFromGenericInput.getNumberValueFromGenericInput;

        _this.setState({
          selectedPackage: _objectSpread({}, selectedPackage, _defineProperty({}, fieldName, getValue(value)))
        });
      };
    }));

    _defineProperty(_assertThisInitialized(_this), "updateIncludedAddonTypes", (0, _lodash.default)(function (value) {
      return function () {
        var tempAddonTypes = _this.state.tempAddonTypes;

        _this.setState({
          tempAddonTypes: tempAddonTypes.includes(value) ? tempAddonTypes.filter(function (addonValue) {
            return addonValue !== value;
          }) : [].concat(_toConsumableArray(tempAddonTypes), [value])
        });
      };
    }));

    _defineProperty(_assertThisInitialized(_this), "updateBillingEntityCode", function (_ref5) {
      var value = _ref5.value;
      var updateBillingEntityCode = _this.props.updateBillingEntityCode;
      updateBillingEntityCode(value);
    });

    _defineProperty(_assertThisInitialized(_this), "selectPackage", function (subPackage) {
      _this.setState({
        selectedPackage: _objectSpread({}, subPackage, {
          custom: false
        })
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onSave", function () {
      var onSave = _this.props.onSave;
      var selectedPackage = _this.state.selectedPackage;

      var selectedPackageWithCustomName = _objectSpread({}, selectedPackage, {
        subStart: createDatePayload(selectedPackage.subStart),
        subEnd: createDatePayload(selectedPackage.subEnd),
        custom: (0, _utils.isCustomPackage)(selectedPackage)
      });

      _this.setState(function () {
        return {
          selectedPackage: selectedPackageWithCustomName,
          assignedPackage: selectedPackageWithCustomName,
          packages: updateLocalPackageTemplate(selectedPackageWithCustomName, _packageTemplates.default)
        };
      }, function () {
        var assignedPackage = _this.state.assignedPackage;
        onSave(assignedPackage);
      });
    });

    _defineProperty(_assertThisInitialized(_this), "openModifyAddons", function () {
      var includedAddonTypes = _this.state.selectedPackage.includedAddonTypes;

      _this.setState({
        tempAddonTypes: includedAddonTypes || [],
        isAddonsOpen: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "closeModifyAddons", function () {
      _this.setState({
        tempAddonTypes: [],
        isAddonsOpen: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "saveIncludedAddons", function () {
      var _this$state = _this.state,
          tempAddonTypes = _this$state.tempAddonTypes,
          selectedPackage = _this$state.selectedPackage;

      _this.setState({
        selectedPackage: _objectSpread({}, selectedPackage, {
          includedAddonTypes: tempAddonTypes
        }),
        tempAddonTypes: [],
        isAddonsOpen: false
      });
    });

    var packageWithDisplayName = (0, _utils.addDisplayNameToPackage)(_assignedPackage);

    var _selectedPackage = packageWithDisplayName || _packageTemplates.default[0];

    _this.state = {
      assignedPackage: _assignedPackage,
      selectedPackage: _selectedPackage,
      packages: packageWithDisplayName ? updateLocalPackageTemplate(packageWithDisplayName) : _packageTemplates.default,
      isAddonsOpen: false,
      tempAddonTypes: []
    };
    return _this;
  }

  _createClass(SubscriptionPackage, [{
    key: "render",
    value: function render() {
      var _this$state2 = this.state,
          assignedPackage = _this$state2.assignedPackage,
          selectedPackage = _this$state2.selectedPackage,
          packages = _this$state2.packages,
          isAddonsOpen = _this$state2.isAddonsOpen,
          tempAddonTypes = _this$state2.tempAddonTypes;
      var _this$props = this.props,
          title = _this$props.title,
          disabled = _this$props.disabled,
          billingEntityCode = _this$props.billingEntityCode;
      var modalProps = isAddonsOpen ? {
        customModalTitle: 'Include Add-ons',
        saveBtnText: 'SAVE CHANGES',
        closeBtnText: 'BACK TO MANAGE SUBSCRIPTION',
        onSave: this.saveIncludedAddons,
        onCloseModal: this.closeModifyAddons,
        onBackClick: this.closeModifyAddons,
        stayOpenOnSave: true
      } : {
        customModalTitle: 'Manage Subscription',
        saveBtnText: 'CONFIRM',
        onSave: this.onSave,
        modalSaveDisabled: isModalSaveDisabled(selectedPackage)
      };
      var packageProps = assignedPackage ? {
        defaultImage: assignedPackage.iconName,
        assignedDescriptions: buildAssignedPackageDescription(assignedPackage),
        assignedName: getPackageName(assignedPackage),
        imageIsIcon: true
      } : {
        defaultImage: 'package'
      };
      var showIncludedAddons = assignedPackage && assignedPackage.includedAddonTypes && assignedPackage.includedAddonTypes.length;
      var footerContent = isAddonsOpen ? _react.default.createElement(_AddonSelector.default, {
        key: selectedPackage.templatedFrom,
        includedAddonTypes: tempAddonTypes,
        onAddonSelect: this.updateIncludedAddonTypes
      }) : void 0;
      return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_SubscriptionBlock.default, _extends({
        id: "subscription-package",
        className: "subscription-package",
        assignmentType: "Packages",
        title: title,
        disabled: disabled
      }, packageProps, modalProps, {
        assignmentModalContent: _react.default.createElement(_ManageSubscription.default, {
          packages: packages,
          packageData: selectedPackage,
          onPackageSelect: this.selectPackage,
          assignmentMatchField: "displayName",
          getItemDisplayName: getPackageName,
          updateCustomPackage: this.updateCustomPackage,
          onModifyAddonsClick: this.openModifyAddons,
          footerContent: footerContent
        })
      })), showIncludedAddons && assignedPackage ? _react.default.createElement("div", {
        className: "subscription-package__addons"
      }, _react.default.createElement("p", null, "Included Add-ons"), _react.default.createElement(_IncludedAddons.default, {
        includedAddonTypes: assignedPackage.includedAddonTypes
      })) : null, assignedPackage ? _react.default.createElement(_uiKit.Dropdown, {
        label: "Billing Region*",
        options: _billingRegions.default,
        onChange: this.updateBillingEntityCode,
        defaultValue: getDefaultBillingEntityCodeOption(billingEntityCode)
      }) : null, _react.default.createElement("hr", {
        className: "subscription-package__divider"
      }));
    }
  }]);

  return SubscriptionPackage;
}(_react.Component);

exports.default = SubscriptionPackage;